export default __webpack_public_path__ + "static/media/1909.825012b8.png";